import React, { useMemo, useState } from 'react'
import { SearchInputGroup } from '@maui/elements'

export const HeaderSearchForm = ({ onCommit, value: query }) => {
  const [value, setValue] = useState(query)
  const onChange = e => setValue(e.target.value)
  const onClear = () => setValue('')
  const onSubmit = e => {
    e.preventDefault()
    onCommit(value)
  }

  useMemo(() => setValue(query), [query])

  return (
    <form onSubmit={onSubmit}>
      <SearchInputGroup
        variant='hairline'
        marginLeft="spaceGapMedium"
        onClear={onClear}
        inputProps={{
          value,
          onChange,
        }}
      />
    </form>
  )
}
